import React, { memo } from "react";
const Divider = memo(() => {
	return (
		<div className="row">
			<div className="col-xs-12">
				<hr />
			</div>
		</div>
	);
});
Divider.displayName = `Divider`;
export default Divider;
